package com.milta.core.localization.translations.de

import com.milta.core.localization.HomeStrings

internal val Home = HomeStrings(
    navTournee = "Tour",
    navEcoDriving = "Eco-Fahren",
    navCommunity = "Community",
    navRewards = "Prämien",
    navHome = "Start",
    navRoutes = "Touren",
    navTeam = "Team",
    navProfile = "Profil",
)
